<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on, attrs }">
        <v-btn dark fab outlined v-bind="attrs" v-on="on">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">{{ $t('rooms.modals.title') }}</v-card-title>
        <TabsDevices />
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TabsDevices from './TabsDevices'

export default {
  name: 'SelectDevicesModal',

  components: {
    TabsDevices
  },

  data() {
    return {
      dialog: false
    }
  }
}
</script>
